import resolveDocumentExportWarningLines, {
	type DocumentExportWarningCounts,
} from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Helpers/resolveDocumentExportWarningLines';
import { css } from '@emotion/react';
import * as React from 'react';

const listStyle = css`
	list-style: disc;
	margin: 0 0 0.75rem;
	padding-left: 1.25rem;
	display: flex;
	flex-direction: column;
	gap: 0.375rem;
`;

const messageStyle = css`
	margin: 0;
`;

type Props = DocumentExportWarningCounts;

/**
 * The confirmation's own message: one line per non-zero count (`resolveDocumentExportWarningLines`),
 * then a closing paragraph that names the consequence in full — kept as a separate element rather
 * than concatenated into a single string, so the two register visually as "the numbers" and "the
 * question".
 */
const DocumentExportWarning: React.FC<Props> = ({ notAddressed, remaining }) => {
	const lines = resolveDocumentExportWarningLines({ notAddressed, remaining });

	return (
		<React.Fragment>
			{lines.length > 0 ? (
				<ul css={listStyle}>
					{lines.map((line) => (
						<li key={line}>{line}</li>
					))}
				</ul>
			) : null}
			<p css={messageStyle}>
				Le fichier reprendra le document tel qu'il est enregistré, et vous en restez responsable.
				Voulez-vous vraiment le télécharger ?
			</p>
		</React.Fragment>
	);
};

export default DocumentExportWarning;
